import React, { useEffect, useState } from "react";
import { 
  Col, 
  Row, 
  DatePicker, 
  Button, 
  Card, 
  Space, 
  Typography, 
  message 
} from "antd";
import { FilterOutlined, ReloadOutlined, CalendarOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import moment from "moment"; // Ensure moment is installed

import ReportBox from "./ReportBox";
// import UpiPaymentSDK from "./UpiPaymentSDK"; // Uncomment if needed

const { Title, Text } = Typography;

function Report() {
  const dispatch = useDispatch();
  
  // --- States ---
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState({});

  const get_category_sale = useSelector((state) =>
    state?.allapi?.get_category_sale ? state?.allapi?.get_category_sale : []
  );

  // --- Initial Load ---
  useEffect(() => {
    fetchData(); 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // --- API Call Function ---
  const fetchData = async (startDate = "", endDate = "") => {
    setLoading(true);
    try {
      // 1. Fetch Report Data
      const payload = {
        from: startDate,
        to: endDate,
      };
      await dispatch(allapiAction.deshBoradDatareport(payload));

      // 2. Fetch Game/Team Data (Optional based on your logic)
      // const response = await dispatch(allapiAction.dashboardGame({}));
      // if (response?.success) {
      //   setFirst(response?.data);
      // }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // --- Filter Handler ---
  const handleFilter = () => {
    if (fromDate && !toDate) {
      message.warning("Please select a 'To Date'");
      return;
    }
    if (!fromDate && toDate) {
      message.warning("Please select a 'From Date'");
      return;
    }

    const start = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    const end = toDate ? moment(toDate).format("YYYY-MM-DD") : "";
    
    fetchData(start, end);
    message.success("Filter Applied");
  };

  // --- Reset Handler ---
  const handleReset = () => {
    setFromDate(null);
    setToDate(null);
    fetchData(); // Calls with empty strings (Full Data)
    message.info("Filters Reset");
  };

  return (
    <div style={{ padding: "20px", backgroundColor: "#f0f2f5", minHeight: "100vh" }}>
      
      {/* --- Header & Filters Section --- */}
      <Card bordered={false} style={{ borderRadius: "10px", marginBottom: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
        <Row gutter={[16, 16]} align="middle" justify="space-between">
          
          {/* Left Side: Title */}
          <Col xs={24} md={8} lg={6}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ background: '#e6f7ff', padding: '10px', borderRadius: '50%', color: '#1890ff' }}>
                <CalendarOutlined style={{ fontSize: '20px' }} />
              </div>
              <div>
                <Title level={4} style={{ margin: 0 }}>Team Report</Title>
                <Text type="secondary" style={{ fontSize: '12px' }}>Check performance by date</Text>
              </div>
            </div>
          </Col>

          {/* Right Side: Filters */}
          <Col xs={24} md={16} lg={18}>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              {/* Space component handles gaps and wrapping automatically */}
              <Space size="middle" wrap style={{ justifyContent: 'flex-end', width: '100%' }}>
                
                {/* From Date */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Text strong style={{ fontSize: '12px', marginBottom: '4px' }}>From:</Text>
                  <DatePicker 
                    value={fromDate} 
                    onChange={(date) => setFromDate(date)} 
                    placeholder="Start Date"
                    style={{ width: '140px' }}
                  />
                </div>

                {/* To Date */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Text strong style={{ fontSize: '12px', marginBottom: '4px' }}>To:</Text>
                  <DatePicker 
                    value={toDate} 
                    onChange={(date) => setToDate(date)} 
                    placeholder="End Date"
                    style={{ width: '140px' }}
                  />
                </div>

                {/* Action Buttons */}
                <div style={{ display: 'flex', alignItems: 'flex-end', height: '56px', paddingBottom: '2px' }}>
                  <Space>
                    <Button 
                      type="primary" 
                      icon={<FilterOutlined />} 
                      onClick={handleFilter}
                      loading={loading}
                    >
                      Search
                    </Button>
                    <Button 
                      icon={<ReloadOutlined />} 
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                  </Space>
                </div>

              </Space>
            </div>
          </Col>
        </Row>
      </Card>

      {/* --- Data Section --- */}
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "10px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
            
            <div style={{ marginBottom: "20px", borderBottom: "1px solid #f0f0f0", paddingBottom: "10px" }}>
              <Title level={5}>Team Data Summary</Title>
            </div>

            {/* Pass Data to ReportBox */}
            <ReportBox first={first} />
            
            {/* <hr style={{ margin: "20px 0", borderTop: "1px solid #f0f0f0" }} />
            <GameData first={first} /> 
            */}

          </div>
        </Col>
      </Row>

    </div>
  );
}

export default Report;